
var LinerReport = (function () {

  function init(title) {
    ChosenSelect.Init();
    datetimepickerRangeInit({ $inputFrom: $('#From'), $inputTo: $('#To'), withSeconds: true });

    $('#export-to-pdf').on('click', function() {
      if ($('svg').length > 0) {
        svg_to_pdf(document.querySelector("svg"), function(pdf) {
          download_pdf(title + '.pdf', pdf.output('dataurlstring'));
        });
      } else {
        alert("Отчет не загружен");
      }
    });
  }

  function onBeginLoading() {
    $('button[type=\"submit\"]').attr('disabled', 'disabled');
    $('#report-data').html('');
    $('#report-trobbler').show();
  }

  function onCompleteLoading() {
    $('button[type=\"submit\"]').removeAttr('disabled');
    $('#report-trobbler').hide();
  }

  return {
    init: init,
    onBeginLoading: onBeginLoading,
    onCompleteLoading: onCompleteLoading
  };

}());

